import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import { Subscription } from "rxjs";
import { CashoutContainer } from "../../containers/CashoutCointainer/CashoutContainer";
import {
    CashoutData,
    handleCashoutData
} from "../../services/handleCashoutData";
// tslint:disable-next-line:no-var-requires
const styles = require("./CashOutScreen.scss");

export function CashOutScreen(props: RouteComponentProps) {
    const resultBetID = extractBetId(props);
    const [activeFilter, setActiveFilter] = useState(Infinity);
    const [
        { currentCashout, currentTimestamp, data, min, max, isBlocked, isError }
    ] = cashoutDataEffect(resultBetID);
    const { t } = useTranslation("cashout");
    const formattedCashout = currentCashout ? currentCashout.toFixed(2) : "-";

    return (
        <div className={styles.greyScreen}>
            <div className={styles.blackBackground}>
                <CashoutContainer
                    isError={isError}
                    isBlocked={isBlocked}
                    currentValue={currentCashout}
                    currentTimestamp={currentTimestamp}
                    onFilterClick={setActiveFilter}
                    activeFilter={activeFilter}
                    data={data}
                    lastPeriodToShow={activeFilter}
                    formatValue={formatCashout}
                    minValue={min}
                    maxValue={max}
                >
                    {t("Cashout", { cashout: formattedCashout })}
                </CashoutContainer>
            </div>
        </div>
    );
}

const extractBetId = (props: RouteComponentProps) =>
    parseInt(
        new URLSearchParams(props.location.search).get("resultBetID") || "",
        10
    );

const cashoutDataEffect = (betId: number) => {
    const [data, setData] = useState<CashoutData>({
        data: [],
        isBlocked: false,
        isError: false
    });
    useEffect(() => {
        const subscription = isNaN(betId)
            ? Subscription.EMPTY
            : handleCashoutData(betId).subscribe(setData);
        return () => subscription.unsubscribe();
    }, [betId]);
    return [data];
};

const formatCashout = (cashout: number | undefined) =>
    cashout !== undefined && !isNaN(cashout) ? `${cashout.toFixed(2)} €` : "";
